import type { CatalogApi } from '../features/catalog/model';

/**
 * "Most used" ordering for platform cards, and the one owner of what that
 * phrase means: requests the platform actually served in the gateway's health
 * window. Endpoint count is a tiebreak only - it measures how much we built,
 * not how much anyone uses it, and reading it as popularity is what put a
 * 26-endpoint platform above a 24-endpoint one with twenty times the traffic.
 */
export const byMostUsed = (a: CatalogApi, b: CatalogApi): number =>
  b.requests - a.requests || b.endpointCount - a.endpointCount || a.name.localeCompare(b.name);
